module.exports = __webpack_public_path__ + "carousel4.689bdbf5.jpg";